import { ChevronRight } from 'lucide-react';
import { deviceTypeList } from './deviceTypes';

interface DeviceTypeSelectorProps {
  onSelect: (typeKey: string) => void;
  onCancel: () => void;
}

export function DeviceTypeSelector({ onSelect, onCancel }: DeviceTypeSelectorProps) {
  return (
    <>
      <div className="camera-form__scroller">
        <div className="device-type-grid">
          {deviceTypeList.map(({ key, title, description, icon: Icon }) => (
            <button
              key={key}
              className="device-type-option"
              type="button"
              onClick={() => onSelect(key)}
              aria-label={`Добавить: ${title}`}
            >
              <span className={`device-type-option__icon device-type-option__icon--${key}`} aria-hidden="true">
                <Icon size={26} strokeWidth={2} />
              </span>
              <span className="device-type-option__copy">
                <strong>{title}</strong>
                <small>{description}</small>
              </span>
              <ChevronRight size={20} strokeWidth={1.8} aria-hidden="true" />
            </button>
          ))}
        </div>
      </div>
      <footer className="camera-dialog__actions">
        <button className="button button--secondary" type="button" onClick={onCancel}>Отмена</button>
      </footer>
    </>
  );
}
